import type { TimeLogEventDTO } from "@pentacode/core";
import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { PUBLIC_PTC_GOOGLE_STATIC_MAPS_KEY } from "../env";
import { shared } from "../styles";

@customElement("ptc-time-log-event-details")
export class TimeLogEventDetails extends LitElement {
    @property({ attribute: false })
    event: TimeLogEventDTO;

    static styles = [shared];

    render() {
        const event = this.event;
        // Without a Static Maps key the map images can't render, so fall back to image-only / nothing.
        const mapLocation = PUBLIC_PTC_GOOGLE_STATIC_MAPS_KEY ? event.location : undefined;
        return html`
            <div class="spacing vertical layout">
                ${event.rejectedReason
                    ? html`
                          <div class="padded red box" style="width: 280px; box-sizing: border-box;">
                              <strong
                                  ><ptc-ui-icon name="icon.status.warning"></ptc-ui-icon> Aktion wurde
                                  abgelehnt.</strong
                              >
                              Grund: ${event.rejectedReason}
                          </div>
                      `
                    : ""}
                ${event.image && mapLocation
                    ? html`
                          <div class="relative">
                              <a
                                  href="https://www.google.com/maps/place/${mapLocation.latitude},${mapLocation.longitude}"
                                  target="_blank"
                              >
                                  <img
                                      src="https://maps.googleapis.com/maps/api/staticmap?markers=${mapLocation.latitude},${mapLocation.longitude}&amp;size=560x560&amp;scale=2&amp;key=${PUBLIC_PTC_GOOGLE_STATIC_MAPS_KEY}"
                                      style="width: 280px; height: 280px; border-radius: 0.5em;"
                                  />
                              </a>

                              <img
                                  class="margined bottom right absolute"
                                  style="width: 100px; height: 100px; border-radius: 0.5em; object-fit: cover; pointer-events: none; -webkit-user-drag: none;"
                                  src=${event.image}
                              />
                          </div>
                      `
                    : event.image
                      ? html`
                            <div>
                                <img
                                    style="width: 280px; height: 280px; border-radius: 0.5em; object-fit: cover; pointer-events: none; -webkit-user-drag: none;"
                                    src=${event.image}
                                />
                            </div>
                        `
                      : mapLocation
                        ? html`
                              <div>
                                  <a
                                      href="https://www.google.com/maps/place/${mapLocation.latitude},${mapLocation.longitude}"
                                      target="_blank"
                                  >
                                      <img
                                          src="https://maps.googleapis.com/maps/api/staticmap?markers=${mapLocation.latitude},${mapLocation.longitude}&amp;size=560x560&amp;scale=2&amp;key=${PUBLIC_PTC_GOOGLE_STATIC_MAPS_KEY}"
                                          style="width: 280px; height: 280px; border-radius: 0.5em;"
                                      />
                                  </a>
                              </div>
                          `
                        : ""}
                ${event.comment
                    ? html`
                          <div part="comment" style="width: 280px; box-sizing: border-box;">
                              <ptc-ui-icon name="icon.object.comment"></ptc-ui-icon>
                              ${event.comment}
                          </div>
                      `
                    : ""}
            </div>
        `;
    }
}
